// extracted by mini-css-extract-plugin
export var wrapper = "team-composition-module--wrapper--3B26j";
export var section = "team-composition-module--section--T8kGC";
export var title = "team-composition-module--title--9l1QJ";
export var stylingArrows = "team-composition-module--styling-arrows---VgJi";